import { useState } from "react";
import axios from "axios";
import { ArrowRight, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FieldnotesForm({ compact = false }) {
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (state === "loading") return;
    setState("loading");
    try {
      await axios.post(`${API}/fieldnotes`, { email, website });
      setState("success");
    } catch {
      setState("error");
    }
  };

  if (state === "success") {
    return (
      <div
        className="border border-glow/40 bg-glow/5 px-5 py-4"
        data-testid="fieldnotes-success-message"
      >
        <div className="flex items-center gap-3">
          <Check size={16} className="shrink-0 text-glow" />
          <p className="text-sm text-slate-200">
            You're on the list. The next Fieldnote will find you.
          </p>
        </div>
        <p className="mt-2 text-xs leading-relaxed text-slate-500">
          If the welcome email doesn't arrive within a few minutes, check your spam folder —
          new senders sometimes land there first.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className={compact ? "" : "w-full"} data-testid="fieldnotes-form">
      <div className="flex flex-col gap-3 sm:flex-row">
        <label htmlFor={compact ? "fn-email-c" : "fn-email"} className="sr-only">
          Email address
        </label>
        <input
          id={compact ? "fn-email-c" : "fn-email"}
          type="email"
          required
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (state === "error") setState("idle");
          }}
          placeholder="you@organisation.co.uk"
          className="field-input flex-1"
          data-testid="fieldnotes-email-input"
        />
        <input
          type="text"
          value={website}
          onChange={(e) => setWebsite(e.target.value)}
          className="hidden"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          name="website"
        />
        <button type="submit" className="btn-primary shrink-0" disabled={state === "loading"} data-testid="fieldnotes-submit-button">
          {state === "loading" ? "Joining…" : "Get the Fieldnotes"}
          <ArrowRight size={14} />
        </button>
      </div>
      {state === "error" && (
        <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-red-400" data-testid="fieldnotes-error-message">
          That didn't go through — check the address and try again.
        </p>
      )}
      <p className="mt-4 text-xs leading-relaxed text-slate-600">
        Occasional, practical, unsubscribe anytime. No hype, no generic productivity advice.
      </p>
    </form>
  );
}
